import { render, staticRenderFns } from "./PurchasedPlans.vue?vue&type=template&id=5274c034"
import script from "./PurchasedPlans.vue?vue&type=script&lang=js"
export * from "./PurchasedPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports